import { type Context } from "react";
import { Store } from "./common";
import { type StoreValue } from "./types";

export function makeStoreProvider<TStoreBaseValue>(
  context: Context<Store<StoreValue<TStoreBaseValue>>>,
) {
  return function StoreProvider(props: {
    initialValue: TStoreBaseValue;
    children: React.ReactNode;
  }) {
    const store = new Store<StoreValue<TStoreBaseValue>>({
      base: props.initialValue,
      idToRequest: {},
    });
    return <context.Provider value={store}>{props.children}</context.Provider>;
  };
}
